import angular from 'angular';
import '../resources/tags';

const module = angular.module('whyline.services.tags', [
  'whyline.resources.tags',
]);

let Tags;

class TagsService {

  static $inject = ['Tags'];

  constructor(injectedTags) {
    Tags = injectedTags;
  }

  GetAll() {
    return Tags.FetchAll();
  }

  GetAllAsPromise() {
    return Tags.FetchAll({
      promise: true,
    });
  }

  GetAllAsPromiseFromServer() {
    return Tags.FetchAll({
      promise: true,
      force: true,
    });
  }

  Update(tags) {
    return Tags.Save(tags);
  }

  Create(tags) {
      let array = [];
    tags.forEach(tag => {
        const newTag = new Tags(tag);
        array.push(newTag);
    })
    return Tags.Save(array);
  }

  Remove(tag) {
    return Tags.Remove(tag);
  }

}

module.exports = module.service('TagsService', TagsService);